import { useSelector } from "react-redux";
import { useAtendimentoSacStorage } from "../storage";
import { buscarImagem } from "../../../../services/aws-s3";
import { buscarOcorrencias } from "../../../../api/AberturaIncidentes";


export const searchColorSistem = (authState) => {

    const dispatch = useAtendimentoSacStorage.getState().dispatch
   
   var {sistemColor, grupoIncidente} = useAtendimentoSacStorage.getState().dados
   
    const payloadCorLogo = {
        "grupo_emp": grupoIncidente,
        "filtros": [
        ]
    }
    buscarOcorrencias(payloadCorLogo).then(response => {

        if (response.data === null) return
        dispatch.setAllData(response.data.parametros.tipos)
        var requestColors = response.data?.parametros?.configuracoes?.cores
        if (requestColors !== undefined) {
            dispatch.setSistemColor({ 
                ...sistemColor, 
                primary: requestColors[0] !== null ? requestColors[0] : sistemColor.primary, 
                secondary: requestColors[1] !== null ? requestColors[1] : sistemColor.secondary })
            }
            
            setTimeout(() => {
                dispatch.setLoadingStartAtendimento(false)
            }, 500);

    })

}